import { render, staticRenderFns } from "./StoryblokNested.vue?vue&type=template&id=a5a8c3a8"
import script from "./StoryblokNested.vue?vue&type=script&lang=ts"
export * from "./StoryblokNested.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports